import { Box, useColorModeValue } from '@chakra-ui/react';
import { cloneElement, ReactElement } from 'react';
import { Link, LinkProps, useLocation } from 'react-router-dom';

interface IActiveLinkProps extends LinkProps {
  children: ReactElement;
  shouldMatchExactHref?: boolean;
}

export function ActiveLink({
  children,
  shouldMatchExactHref = false,
  ...rest
}: IActiveLinkProps) {
  let isActive = false;
  const { pathname } = useLocation();

  if (
    shouldMatchExactHref &&
    (pathname === rest.href || pathname === rest.to)
  ) {
    isActive = true;
  }

  if (
    !shouldMatchExactHref &&
    (pathname.startsWith(String(rest.href)) ||
      pathname.startsWith(String(rest.to)))
  ) {
    isActive = true;
  }

  const bg = useColorModeValue('gray.100', 'gray.900');
  const color = useColorModeValue('blue.600', 'blue.200');

  return (
    <Box
      _hover={{
        bg,
        borderRadius: '2xl',
      }}
      w="100%"
      px="6"
      py="3"
    >
      <Link {...rest}>
        {cloneElement(children, {
          color: isActive ? color : 'gray.500',
        })}
      </Link>
    </Box>
  );
}
